export default "__VITE_ASSET__55797c70__"